import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type Title2Props = RNTextProps & {
  weight?: 'regular' | 'semibold';
};

export const Title2: React.FC<Title2Props> = ({
  children,
  weight = 'regular',
  style,
  ...props
}) => {
  return (
    <RNText style={[s.common, s.title2, getFontFamily(weight), style]} {...props}>
      {children}
    </RNText>
  );
};
